// Only public catalog text is eligible. Never include orders, customers or credentials.
const textFields = new Set([
  "name", "nombre", "description", "descripcion", "title", "label",
  "categoryName", "subcategoryName", "promptTitle", "promptLabel", "selectionTitle",
  "titleOverride", "visibleTitle", "groupLabel", "scheduleSummary", "validity",
  "pricingSummary", "detail", "details", "customLabel", "displayName", "productName",
  "hook", "targetLabel",
]);

export function collectMenuTranslationTexts(menu, promotions = []) {
  const texts = new Set();
  const visit = (value, depth = 0) => {
    if (!value || typeof value !== "object" || depth > 12) return;
    if (Array.isArray(value)) { value.forEach((item) => visit(item, depth + 1)); return; }
    for (const [key, item] of Object.entries(value)) {
      if (textFields.has(key) && typeof item === "string") {
        const text = item.trim();
        if (text && text.length <= 6000 && !/^(https?:|data:)/i.test(text)) texts.add(text);
      } else if (item && typeof item === "object") visit(item, depth + 1);
    }
  };
  visit(menu?.categories);
  visit(menu?.products);
  visit(menu?.linkedRules);
  visit(promotions);
  return [...texts].sort();
}

export function validateMenuTranslations(source, result) {
  if (!Array.isArray(result) || result.length !== source.length) throw new Error("Incomplete translation");
  const translations = Object.create(null);
  result.forEach((item, index) => {
    if (typeof item !== "string" || !item.trim() || item.length > Math.max(1000, source[index].length * 5)) {
      throw new Error("Invalid translation");
    }
    // Portions, measures, times and other numbers must remain exactly as in the source.
    const numbers = (text) => (text.match(/\d+(?:[.,:]\d+)*/g) || []).sort().join("|");
    if (numbers(source[index]) !== numbers(item)) throw new Error("Translation changed quantities");
    translations[source[index]] = item.trim();
  });
  return translations;
}

export function protectMenuTranslationNumbers(source) {
  let prefix = "__MOZZO_NUMBER_";
  const hasMarker = (candidate) => source.some((value) => value.includes(candidate));
  while (hasMarker(prefix)) prefix = `_${prefix}`;
  const numbers = source.map(() => []);
  const texts = source.map((value, index) => value.replace(/\d+(?:[.,:]\d+)*/g, (number) => {
    numbers[index].push(number);
    return `${prefix}${numbers[index].length - 1}__`;
  }));
  return {
    texts,
    restore(result) {
      if (!Array.isArray(result) || result.length !== source.length) throw new Error("Incomplete translation");
      return result.map((value, index) => {
        if (typeof value !== "string") throw new Error("Invalid translation");
        let restored = value;
        numbers[index].forEach((number, position) => {
          const marker = `${prefix}${position}__`;
          if (restored.split(marker).length !== 2) throw new Error("Translation changed number placeholders");
          restored = restored.replace(marker, number);
        });
        if (restored.includes(prefix)) throw new Error("Unknown number placeholder");
        return restored;
      });
    },
  };
}
